module.exports = __webpack_public_path__ + "img/card_bg_等级徽章@2x.74498784.png";